import React from "react"

const Completion = () => {
  return (
    <div className="text-center text-[4em] font_styling h-[100vh] align-middle justify-center">
      Thank You🥰 <br /> THE PAYMENT IS COMPLETED
    </div>
  )
}

export default Completion
